export default __webpack_public_path__ + "static/partnerIcon19-2beea4fe8b15880c47624a99310a6d97.svg";